import styled from 'styled-components';

import { PaginationFooter } from 'ui/paginationFooter';
import { spacing, letterSpacing, mediumShadow } from 'ui/theme';
import { usePaginationContext } from 'utils/contexts/pagination';

import { useEventHistoryQueryContext } from '../contexts/EventHistoryQueryContext';
import { HeaderRow } from './HeaderRow';
import { EventHistoryRow } from './EventHistoryRow';
import { SkeletonRows } from './SkeletonRows';
import { ORDERED_TABLE_COLUMNS, TABLE_COLUMN_WIDTHS } from '../constants';
import { NoResultsPlaceholder } from './NoResultsPlaceholder';
import { Table } from '../../../components/table';

const Wrapper = styled.div`
  box-shadow: ${mediumShadow.boxShadow};
  border-radius: ${spacing.half};
  letter-spacing: ${letterSpacing.pos10};
`;

const PaginationWrapper = styled.div`
  grid-column: 1 / span ${ORDERED_TABLE_COLUMNS.length};
  padding-bottom: ${spacing.base};
`;

export const EventHistoryTable = () => {
  const { currentPage, pageSize, setCurrentPage, setPageSize } = usePaginationContext();
  const { totalUserEventCount, userEvents, isLoading } = useEventHistoryQueryContext();

  return (
    <Wrapper data-test="event-history-table">
      <Table columns={ORDERED_TABLE_COLUMNS.map((id) => ({ id, width: TABLE_COLUMN_WIDTHS[id] }))}>
        <HeaderRow />
        {isLoading && <SkeletonRows isLoading={isLoading} userEvents={userEvents} />}
        {!isLoading &&
          userEvents.map((event, i) => (
            <EventHistoryRow key={`event-${event.createdAt}-${i}`} event={event} index={i} />
          ))}
        {!isLoading && totalUserEventCount === 0 && <NoResultsPlaceholder />}
        <PaginationWrapper>
          <PaginationFooter
            currentPage={currentPage}
            itemsPerPage={pageSize}
            onUpdate={(event) => {
              setCurrentPage(event.page);
              setPageSize(event.pageSize);
            }}
            numItems={totalUserEventCount}
          />
        </PaginationWrapper>
      </Table>
    </Wrapper>
  );
};
